export const HOME = "/";
export const CONTACT = "/contact";
export const PROJECTS = "/projects";
export const PROJECTDETAILS = "/project/:_projectId";
